import React from 'react';
import '../styles/Modal.css';

interface ModalProps {
  show: boolean;
  onClose: () => void;
  content: string;
}

const modalContent = {
  terms: `
    <h2>Điều khoản sử dụng</h2>
    <div class="modal-text">
      <p>1. Điều khoản chung</p>
      <p>Bằng việc truy cập và sử dụng dịch vụ này, bạn đồng ý tuân thủ và chịu ràng buộc bởi các điều khoản và điều kiện sau đây.</p>
      
      <p>2. Quyền và nghĩa vụ của thành viên</p>
      <p>- Thành viên có quyền sử dụng các dịch vụ được cung cấp theo đúng mục đích.</p>
      <p>- Thành viên phải cung cấp thông tin chính xác và đầy đủ khi đăng ký.</p>
      
      <p>3. Bảo mật thông tin</p>
      <p>Chúng tôi cam kết bảo vệ thông tin cá nhân của bạn theo chính sách bảo mật.</p>
    </div>
  `,
  privacy: `
    <h2>Chính sách bảo mật</h2>
    <div class="modal-text">
      <p>1. Thu thập thông tin</p>
      <p>Chúng tôi chỉ thu thập thông tin cần thiết để cung cấp dịch vụ cho bạn.</p>
      
      <p>2. Sử dụng thông tin</p>
      <p>Thông tin của bạn sẽ được sử dụng để:</p>
      <p>- Cung cấp và duy trì dịch vụ</p>
      <p>- Cải thiện trải nghiệm người dùng</p>
      <p>- Gửi thông báo quan trọng</p>
      
      <p>3. Bảo vệ thông tin</p>
      <p>Chúng tôi áp dụng các biện pháp bảo mật để bảo vệ thông tin của bạn.</p>
    </div>
  `,
  success: `
    <div class="success-modal">
      <h2>Đăng ký thành công!</h2>
      <p>Cảm ơn bạn đã đăng ký thành viên tại Matcha Hitotsu. Chúc bạn có những hành trình matcha thú vị cùng Matcha Hitotsu.</p>
    </div>
  `
};

export const Modal: React.FC<ModalProps> = ({ show, onClose, content }) => {
  if (!show) return null;

  return (
    <div className="modal" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <span className="close-modal" onClick={onClose}>&times;</span>
        <div dangerouslySetInnerHTML={{ __html: modalContent[content as keyof typeof modalContent] }} />
      </div>
    </div>
  );
}; 